import React from 'react';
import { AlertCircle, Check, Icon } from '@onward-delivery/design/icons';
import Pill from '../Pill';
import { COMPLIANCE_DOC_LABELS } from '../constants';

const ComplianceBadges = ({ compliance = [], onUpload }) => (
    <div className="flex flex-wrap items-center gap-2">
        {compliance.map(({ type, satisfied }) => {
            const label = COMPLIANCE_DOC_LABELS[type] || type;

            return (
                <button key={type} type="button" onClick={() => onUpload(type)} aria-label={`Upload ${label}`}>
                    <Pill tone={satisfied ? 'complianceMet' : 'complianceMissing'}>
                        <Icon icon={satisfied ? Check : AlertCircle} size="sm" className="size-3 shrink-0" />
                        {label}
                    </Pill>
                </button>
            );
        })}
    </div>
);

export default ComplianceBadges;
